import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

import { LanguageItem, Props as LanguageItemProps } from './LanguageItem'

export interface Props {
  isSticky?: boolean
  languagesList: LanguageItemProps[]
  languagePrefix: string
}

export const Languages = memo(function Languages({
  isSticky,
  languagesList,
  languagePrefix,
}: Props) {
  const [animObjectRef, isAnimObjectVisible] = useInView({
    triggerOnce: true,
  })

  return (
    <Container
      className={`${isSticky ? 'is-sticky' : ''}${
        isAnimObjectVisible ? ' visible' : ''
      }`}
      dial={6}
      ref={animObjectRef}
      row
    >
      {languagesList
        .sort((a: any, b: any) => a.sort - b.sort)
        .map((item, index) => (
          <LanguageItem currentPrefix={languagePrefix} key={index} {...item} />
        ))}
    </Container>
  )
})

const Container = styled(FlexBox)`
  border-left: 0.0625rem solid ${rgba(theme.colors.variants.neutralLight1, 0.2)};
  margin-left: 1.5rem;
  padding-left: 1.5rem;
  opacity: 0;
  transition: 1s 0.8s ease-in-out;
  transform: translateY(-2.5rem);
  z-index: 3;
  &.visible {
    opacity: 1;
    transform: none;
  }
  &.is-sticky {
    border-color: ${rgba(theme.colors.variants.primaryDark, 0.2)};
    opacity: 1 !important;
    transition: none !important;

    a {
      color: ${({ theme }) => theme.colors.variants.primaryDark};
    }
  }
`
